module.exports = __webpack_public_path__ + "img/newlogo.5019e5a9.png";